export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8713.b7f33e2f.jpg";